<template lang="pug">
div
  details-campaign
  v-divider.basic500.my-5
  details-cover-photo
  v-divider.basic500.my-5
  details-donation-amounts
  v-divider.basic500.my-5
  details-story

</template>

<script>
import DetailsCampaign from '@/components/donation/campaign/DetailsCampaign.vue'
import DetailsCoverPhoto from '@/components/donation/campaign/DetailsCoverPhoto.vue'
import DetailsDonationAmounts from '@/components/donation/campaign/DetailsDonationAmounts.vue'
import DetailsStory from '@/components/donation/campaign/DetailsStory.vue'

export default {
  name: 'ManageCampaignDetails',
  components: { DetailsCampaign, DetailsCoverPhoto, DetailsDonationAmounts, DetailsStory },
}
</script>

<style scoped>

</style>